import { Typography, Box } from "@mui/material";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { MonthlyIncome, StatisticsModel } from "../../core/api/statistics/StatisticsModel";

const IncomeLineChart: React.FC = () => {
  const [data, setData] = useState<MonthlyIncome[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const incomeData = await StatisticsModel.getMonthlyIncome();
      setData(incomeData.map(item => ({
        ...item,
        date: format(parseISO(item.date), "yyyy-MM"),
      })));
    };

    fetchData().catch(console.error);
  }, []);

  const xLabels = data.map(item => item.date);
  const totalPriceData = data.map(item => item.totalPrice);
  const totalPvmData = data.map(item => item.totalPvm);
  const sumData = data.map(item => item.sum);

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      bgcolor: 'background.paper',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box sx={{ 
        p: 2, 
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <Typography variant="h6">Mėnesinės pajamos (grafikas)</Typography>
      </Box>
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <LineChart
          series={[
            {
              data: totalPriceData,
              label: 'Kaina',
              color: '#8884d8',
            },
            {
              data: totalPvmData,
              label: 'PVM',
              color: '#82ca9d',
            },
            {
              data: sumData,
              label: 'Suma',
              color: '#ffc658',
            },
          ]}
          xAxis={[{
            data: xLabels,
            scaleType: 'band',
          }]}
          slotProps={{
            legend: {
              hidden: false,
            },
          }}
          grid={{ vertical: true, horizontal: true }}
          height={350}
          margin={{ top: 20, right: 30, left: 40, bottom: 40 }}
        />
      </Box>
    </Box>
  );
};

export default IncomeLineChart;
